import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrawCollapseDirectiveSharedModule } from '@shared/core/directives/drawCollapse';
import { HeadersModule } from '@shared/core/components/headers';
import { ButtonsModule } from '@shared/core/components/buttons';
import { OpenStatusModule } from '@shared/core/components/openStatus';
import { DropDownModule } from '@shared/core/components/dropDown';
import { EmphasisTextModule } from '@shared/core/components/emphasisText';
import { PickupModule } from '@shared/core/components/pickup';
import { CollectionTypeToggleModule } from '@shared/core/components/collectionTypeToggle';

import { LocationsHeroHeaderComponent } from './locations-hero-header.shared.component';

@NgModule({
    declarations: [
        LocationsHeroHeaderComponent
    ],
    imports: [
        DrawCollapseDirectiveSharedModule,
        CommonModule,
        HeadersModule,
        ButtonsModule,
        OpenStatusModule,
        DropDownModule,
        EmphasisTextModule,
        PickupModule,
        CollectionTypeToggleModule,
    ],
    exports: [
        LocationsHeroHeaderComponent
    ],
})
export class LocationsHeroHeaderModule { }
